import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import facebookActions from "modules/facebook/actions";
import facebookSelectors from "modules/facebook/selectors";
import mainActions from "modules/main/actions";
import { Text, TextTitle, TextHeader, TextDescription } from "components/Texts";
import Input from "components/Inputs";
import Dropdown from "components/Dropdown";
import Button from "components/Buttons";
import Column from "components/Column";
import Row from "components/Row";
import Toast from "components/Toast";
import LoadingContainer from "components/LoadingContainer";
import LoginModal from "components/facebook/LoginModal";
import { useTranslation } from "react-i18next";

function AdsSetup() {
  const { REACT_APP_FACEBOOK_ADS_SETUP_MANUAL_URL } = process.env;
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [selectedFacebookBusinessId, setSelectedFacebookBusinessId] = useState(false);
  const [selectedFacebookBusinessName, setSelectedFacebookBusinessName] = useState(false);
  const [selectedFacebookAdsAccountId, setSelectedFacebookAdsAccountId] = useState(false);
  const [selectedFacebookAdsAccountName, setSelectedFacebookAdsAccountName] = useState(false);
  const [selectedFacebookPixelId, setSelectedFacebookPixelId] = useState("");
  const [businessDefaultIndex, setBusinessDefaultIndex] = useState(0);
  const [adsDefaultIndex, setAdsDefaultIndex] = useState(0);
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [validateBusinessFailed, setValidateBusinessFailed] = useState(false);
  const [validateAdsAccountFailed, setValidateAdsAccountFailed] = useState(false);
  const [validatePixelFailed, setValidatePixelFailed] = useState(false);
  const [validatePixelPermissionFailed, setValidatePixelPermissionFailed] = useState(false);
  const [validatePixelConnectedAdsFailed, setValidatePixelConnectedAdsFailed] = useState(false);
  const [validateAdsAssignPartnerFailed, setValidateAdsAssignPartnerFailed] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showFailedToast, setShowFailedToast] = useState(false);
  const [showValidateFailedToast, setShowValidateFailedToast] = useState(false);
  const [showLoginFailedToast, setShowLoginFailedToast] = useState(false);
  const [hasDaSettings, setHasDaSettings] = useState(false);
  const [showLoadingContainer, setShowLoadingContainer] = useState(false);
  const getFacebookSettingsResult = useSelector((state) => facebookSelectors.getFacebookSettingsResult(state));
  const [reload, setReload] = useState(0);
  const [dropdownBusinesses, setDropdownBusiness] = useState([
    {
      title: "-",
    },
  ]);
  const [dropdownAdsAccounts, setDropdownAdsAccounts] = useState([
    {
      title: "-",
    },
  ]);

  const getFacebookApiTokenResult = useSelector((state) => facebookSelectors.getFacebookApiTokenResult(state));
  const getFacebookBusinessListResult = useSelector((state) => facebookSelectors.getFacebookBusinessListResult(state));
  const getFacebookAdsAccountListResult = useSelector((state) =>
    facebookSelectors.getFacebookAdsAccountListResult(state),
  );
  const getFacebookDaSettingsResult = useSelector((state) => facebookSelectors.getFacebookDaSettingsResult(state));
  const [modalLoginFacebookDisplay, setModalLoginFacebookDisplay] = useState("hide");

  const handleLoginFacebookModal = () => {
    setModalLoginFacebookDisplay("show");
  };

  const initData = () => {
    setDropdownBusiness([
      {
        title: "-",
      },
    ]);

    setDropdownAdsAccounts([
      {
        title: "-",
      },
    ]);

    setSelectedFacebookBusinessId(false);
    setSelectedFacebookBusinessName(false);
    setSelectedFacebookAdsAccountId(false);
    setSelectedFacebookAdsAccountName(false);
    setSelectedFacebookPixelId("");
    setBusinessDefaultIndex(0);
    setAdsDefaultIndex(0);
  };

  const handleReload = () => {
    setReload(reload + 1);
    setModalLoginFacebookDisplay("hide");
  };

  useEffect(() => {
    initData();

    FB.getLoginStatus(function (response) {
      if (response.status === "connected") {
        getAllAccountData(response.authResponse);
      }
    });
  }, [reload]);

  useEffect(() => {
    let foundSelectedBusiness = false;
    let filteredDropdown = [];

    if (getFacebookBusinessListResult.data.data && getFacebookBusinessListResult.data.data.length > 0) {
      for (let i = 0; i < getFacebookBusinessListResult.data.data.length; i += 1) {
        filteredDropdown.push({
          title: getFacebookBusinessListResult.data.data[i].name,
        });

        if (
          getFacebookSettingsResult.data[0] &&
          getFacebookBusinessListResult.data.data[i].id ===
            getFacebookSettingsResult.data[0].fb_ads_business_id
        ) {
          handleOnSelectBusiness("", i);
          foundSelectedBusiness = true;
        }
      }

      setDropdownBusiness(filteredDropdown);

      if (!foundSelectedBusiness) {
        handleOnSelectBusiness("", 0);
      }
    }
  }, [getFacebookBusinessListResult]);

  useEffect(() => {
    let foundSelectedAds = false;

    let filteredDropdown = [];

    if (getFacebookAdsAccountListResult.data.data && getFacebookAdsAccountListResult.data.data.length > 0) {
      for (let i = 0; i < getFacebookAdsAccountListResult.data.data.length; i += 1) {
        filteredDropdown.push({
          title: getFacebookAdsAccountListResult.data.data[i].name,
          ads_account_id: getFacebookAdsAccountListResult.data.data[i].account_id,
          index: i,
        });

        if (
          getFacebookSettingsResult.data[0] &&
          getFacebookAdsAccountListResult.data.data[i].account_id ===
            getFacebookSettingsResult.data[0].fb_ads_account_id
        ) {
          setAdsDefaultIndex(i);
          setSelectedFacebookAdsAccountId(
            getFacebookSettingsResult.data[0].fb_ads_account_id
          );
          setSelectedFacebookAdsAccountName(
            getFacebookSettingsResult.data[0].fb_ads_account_name
          );
          foundSelectedAds = true;
        }
      }

      setDropdownAdsAccounts(filteredDropdown);
      if (!foundSelectedAds) {
        setAdsDefaultIndex(0);
        setSelectedFacebookAdsAccountId(getFacebookAdsAccountListResult.data.data[0].account_id);
        setSelectedFacebookAdsAccountName(getFacebookAdsAccountListResult.data.data[0].name);
      }
    } else {
        setAdsDefaultIndex(0);
        setSelectedFacebookAdsAccountId(false);
        setSelectedFacebookAdsAccountName(false);
    }
    setValidateAdsAccountFailed(false);
    setValidateAdsAssignPartnerFailed(false);

  }, [getFacebookAdsAccountListResult]);

  const reLogin = () => {
    if (saveButtonLoading !== true) {
      setModalLoginFacebookDisplay("show");
    }
  };

  const validateInputs = () => {
    let result = true;

    if (!selectedFacebookBusinessId || selectedFacebookBusinessId === "") {
      result = false;
      setValidateBusinessFailed(true);
    } else {
      setValidateBusinessFailed(false);
    }

    if (!selectedFacebookAdsAccountId || selectedFacebookAdsAccountId === "") {
      result = false;
      setValidateAdsAccountFailed(true);
    } else {
      setValidateAdsAccountFailed(false);
    }

    if (!selectedFacebookPixelId || selectedFacebookPixelId === "") {
      result = false;
      setValidatePixelFailed(true);
    } else {
      setValidatePixelFailed(false);
    }

    if (result !== true) {
      setShowValidateFailedToast(true);
    }

    return result;
  };

  const getAllAccountData = async (authData) => {
    setShowLoadingContainer(true);

    const facebookSettings = await dispatch(
      facebookActions.getFacebookSettings({
        token: rmpToken,
      }),
    );

    if (
      !getFacebookBusinessListResult.data.data ||
      getFacebookBusinessListResult.data.data.length === 0 ||
      reload > 0
    ) {
      const facebookBusinessList = await dispatch(
        facebookActions.getFacebookBusinessList({
          user_id: authData.userID,
          user_access_token: getFacebookApiTokenResult.facebookApiAccessToken,
          token: rmpToken,
        }),
      );
      if(!facebookBusinessList.data.data.length) {
        setShowLoadingContainer(false);
      }
    }

    if (
      facebookSettings.result === 0 &&
      facebookSettings.data.length > 0 &&
      facebookSettings.data[0].fb_ads_pixel_code_id
    ) {
      setSelectedFacebookPixelId(facebookSettings.data[0].fb_ads_pixel_code_id);
    }

  };

  const handleOnSelectBusiness = async (item, index) => {
    // Set Selected Facebook Business and skip index 0
    setBusinessDefaultIndex(index);
    setShowLoadingContainer(true);
    setSelectedFacebookBusinessId(getFacebookBusinessListResult.data.data[index].id);
    setSelectedFacebookBusinessName(getFacebookBusinessListResult.data.data[index].name);
    setValidateBusinessFailed(false);
    setDropdownAdsAccounts([
      {
        title: "-",
      },
    ]);

    setAdsDefaultIndex(0);

    await dispatch(
      facebookActions.getFacebookAdsAccountList({
        fbBusinessId: getFacebookBusinessListResult.data.data[index].id,
        userAccessToken: getFacebookApiTokenResult.facebookApiAccessToken,
        token: rmpToken,
      }),
    );

    setShowLoadingContainer(false);
  };

  const handleOnSelectAdsAccount = (item, index) => {
    // Set Selected Facebook Ads Account and skip index 0
    if (selectedFacebookAdsAccountId !== item.ads_account_id) {
      setAdsDefaultIndex(item.index);
      setSelectedFacebookAdsAccountId(item.ads_account_id);
      setSelectedFacebookAdsAccountName(item.title);
      setValidateAdsAccountFailed(false);
      setValidateAdsAssignPartnerFailed(false);
    }
  };

  const handleOnChangePixelId = (value) => {
    setSelectedFacebookPixelId(value);
    setValidatePixelFailed(false);
    setValidatePixelPermissionFailed(false);
    setValidatePixelConnectedAdsFailed(false);
  };

  const successToastCallback = (value) => {
    if (showSuccessToast !== value) {
      setShowSuccessToast(value);
    }

    if (value === false) {
      setSaveButtonLoading(false);
      dispatch(facebookActions.changeSettingPage("connected"));
    }
  };

  const failedToastCallback = (value) => {
    setShowFailedToast(value);
  };

  const loginFailedToastCallback = (value) => {
    setShowLoginFailedToast(value);
  };

  const validateFailedToastCallback = (value) => {
    setShowValidateFailedToast(value);
  };

  const handleSaveButton = async () => {
    setSaveButtonLoading(true);
    const validateInputResults = validateInputs();
    const failedStepList = {
      business: "business_setup_failed",
      ads: "ads_setup_failed",
      pixel: "pixel_setup_failed",
    };
    let result = true;
    let setupStatus = "completed";
    let isRpAccount = false;

    if (!validateInputResults) {
      setSaveButtonLoading(false);
      return false;
    }

    try {
      const createAdAccountAgencyResult = await createAgencyAdAccount();

      if (createAdAccountAgencyResult !== true) {
        result = false;
        setupStatus = failedStepList.ads;
        setValidateAdsAssignPartnerFailed(true);
      } else {
        setValidateAdsAssignPartnerFailed(false);
      }
    } catch (error) {
      if (error.code === 3946 || error.message === "Asset already belongs to this Business Manager.") {
        isRpAccount = true;
      } else {
        result = false;
        setupStatus = failedStepList.ads;
        setValidateAdsAssignPartnerFailed(true);
      }
    }

    try {
      if (result === true) {
        const inviteAdsAccountUserResult = await dispatch(
          facebookActions.inviteFacebookAdsAccount({
            ads_account_id: selectedFacebookAdsAccountId,
            user_access_token: getFacebookApiTokenResult.facebookApiAccessToken,
            token: rmpToken,
          }),
        );

        if (inviteAdsAccountUserResult.result !== 0) {
          result = false;
          setupStatus = failedStepList.ads;
          setValidateAdsAssignPartnerFailed(true);
        } else {
          setValidateAdsAssignPartnerFailed(false);
        }
      }
    } catch (error) {
      if (error.code !== 3946 && error.message !== "Asset already belongs to this Business Manager.") {
        result = false;
        setupStatus = failedStepList.ads;
        setValidateAdsAssignPartnerFailed(true);
      }
    }

    try {
      const getPixelAgencyResult = await dispatch(
        facebookActions.getFacebookPixelAgencies({
          token: rmpToken,
          ads_account_id: selectedFacebookAdsAccountId,
          user_access_token: getFacebookApiTokenResult.facebookApiAccessToken,
          pixels_id: selectedFacebookPixelId,
        }),
      );

      if (getPixelAgencyResult.result !== 0) {
        if (
          getPixelAgencyResult.message === "NO_CONNECTED_ADS" ||
          getPixelAgencyResult.message === "NO_CONNECTED_ADS_AND_RP_AGENCY"
        ) {
          result = false;
          setupStatus = failedStepList.pixel;
          setValidatePixelPermissionFailed(false);
          setValidatePixelConnectedAdsFailed(true);
        } else if (isRpAccount && getPixelAgencyResult.message === "NO_RP_AGENCY") {
          // Do Nothing
        } else if (result !== true) {
          // Do Nothing
        } else {
          result = false;
          setupStatus = failedStepList.pixel;
          setValidatePixelConnectedAdsFailed(false);
          setValidatePixelPermissionFailed(true);
        }
      }

      // Set Facebook Settings
      const setupResult = await dispatch(
        facebookActions.setFacebookSettings({
          token: rmpToken,
          fbBusinessId: selectedFacebookBusinessId,
          fbBusinessName: selectedFacebookBusinessName,
          fbAdsId: selectedFacebookAdsAccountId,
          fbAdsName: selectedFacebookAdsAccountName,
          fbPixelCodeId: selectedFacebookPixelId,
          setupStatus: setupStatus,
        }),
      );

      if (setupStatus === "completed" && setupResult.result === 0) {
        setShowSuccessToast(true);
      } else {
        throw new Error("FACEBOOK_SETUP_FAILED");
      }
    } catch (error) {
      setShowFailedToast(true);
      setSaveButtonLoading(false);
    }
  };

  function createAgencyAdAccount() {
    return new Promise((resolve, reject) => {
      FB.api(
        "https://graph.facebook.com/" +
          process.env.REACT_APP_FACEBOOK_GRAPH_API_VERSION +
          "/act_" +
          selectedFacebookAdsAccountId +
          "/agencies",
        "POST",
        {
          permitted_tasks: ["MANAGE", "ADVERTISE", "ANALYZE"],
          business: process.env.REACT_APP_FACEBOOK_RP_BUSINESS_ID,
          access_token: getFacebookApiTokenResult.facebookApiAccessToken,
        },
        function (response) {
          if (
            !response ||
            (response.error &&
              response.error.code !== 3989 &&
              response.error.message !== "You are trying to assign a duplicated asset to this agency.")
          ) {
            reject(response.error);
          } else {
            resolve(true);
          }
        },
      );
    });
  }

  const loginToRdynamic = async () => {
    const loginResult = await dispatch(
      mainActions.loginToRdynamic({
        token: rmpToken,
      }),
    );

    if (loginResult.result === 0) {
      window.open(`${loginResult.appOtpUrl}&target=facebook`, "_blank");
    } else {
      setShowLoginFailedToast(true);
    }
  };

  return (
    <StyledContainer>
      <SetupWrapperHeader>
        <SetupTextHeader>{t("__fbads_setup_title")}</SetupTextHeader>
      </SetupWrapperHeader>

      <SetupMainContainer>
        <div>{t("__fbads_setup_sub_title")}</div>
        <StyledRow>
          <Column>
            <TextDescription size="10px">{t("__fbads_setup_account_business")}</TextDescription>
            {hasDaSettings !== true && (
              <>
                <Dropdown
                  items={dropdownBusinesses}
                  onSelected={handleOnSelectBusiness}
                  defaultIndex={businessDefaultIndex}
                  minWidth="100%"
                  selectedIndex={businessDefaultIndex}
                />
                <InputError className={validateBusinessFailed ? "input-error" : ""}>
                  {t("__fbads_setup_error_no_business")}
                </InputError>
              </>
            )}
            {hasDaSettings === true && <StyledInput type="text" full disabled value={selectedFacebookBusinessName} />}
          </Column>
          <Column>
            <TextDescription size="10px">{t("__fbads_setup_account_ads")}</TextDescription>
            {hasDaSettings !== true && (
              <>
                <Dropdown
                  items={dropdownAdsAccounts}
                  onSelected={handleOnSelectAdsAccount}
                  defaultIndex={adsDefaultIndex}
                  minWidth="100%"
                  selectedIndex={adsDefaultIndex}
                  searchType={true}
                />
                <InputError className={validateAdsAccountFailed ? "input-error" : ""}>
                  {t("__fbads_setup_error_no_ads_account")}
                </InputError>
              </>
            )}
            {hasDaSettings === true && <StyledInput type="text" full disabled value={selectedFacebookAdsAccountName} />}
            <InputError className={validateAdsAssignPartnerFailed ? "input-error" : ""}>
              {t("__fbads_setup_error_access_ads_account")}
            </InputError>
          </Column>
        </StyledRow>
        <StyledRow>
          <Column>
            <TextDescription size="10px">{t("__fbads_setup_account_pixel")}</TextDescription>
            <Row alignItems="stretch">
              {hasDaSettings !== true && (
                <StyledInput
                  type="text"
                  full
                  onChange={(event) => handleOnChangePixelId(event.target.value)}
                  value={selectedFacebookPixelId}
                />
              )}
              {hasDaSettings === true && <StyledInput type="text" full disabled value={selectedFacebookPixelId} />}
            </Row>
            <InputError className={validatePixelFailed ? "input-error" : ""}>
              {t("__fbads_setup_error_no_pixel")}
            </InputError>
            <InputError className={validatePixelPermissionFailed ? "input-error" : ""}>
              {t("__fbads_setup_error_access_pixel")}&nbsp;
              <a href={REACT_APP_FACEBOOK_ADS_SETUP_MANUAL_URL} target="_blank">
                {t("__fbads_setup_more_details")}
              </a>
            </InputError>
            <InputError className={validatePixelConnectedAdsFailed ? "input-error" : ""}>
              {t("__fbads_setup_error_connected_pixel_ads")}&nbsp;
              <a href={REACT_APP_FACEBOOK_ADS_SETUP_MANUAL_URL} target="_blank">
                {t("__fbads_setup_more_details")}
              </a>
            </InputError>
          </Column>
          <Column></Column>
        </StyledRow>
        {hasDaSettings === true && (
          <StyledRow>
            <SetupWrapperFooter>
              <LoginToRdynamicContainer>
                <span>{t("__fbads_facebook_setting_edit_on_rdynamic")}</span>&nbsp;
                <LoginToRdynamicLink onClick={loginToRdynamic}>
                  {t("__fbads_facebook_setting_edit_on_rdynamic_click_here")}
                </LoginToRdynamicLink>
              </LoginToRdynamicContainer>
            </SetupWrapperFooter>
          </StyledRow>
        )}
        <StyledRow>
          <SetupWrapperFooter>
            <ReLoginContainer onClick={reLogin}>{t("__fbads_setup_change_account_button")}</ReLoginContainer>
            <SaveButton type="loading" onClick={handleSaveButton} loading={saveButtonLoading}>
              {t("__fbads_setup_save_button")}
            </SaveButton>
          </SetupWrapperFooter>
        </StyledRow>
      </SetupMainContainer>

      <Toast
        show={showSuccessToast}
        message={t("__fbads_setup_save_success")}
        bgColor="#4CAF50"
        callback={successToastCallback}
      ></Toast>
      <Toast
        show={showFailedToast}
        message={t("__fbads_setup_save_failed")}
        bgColor="#F44336"
        callback={failedToastCallback}
      ></Toast>
      <Toast
        show={showValidateFailedToast}
        message={t("__fbads_facebook_setting_validate_failed")}
        bgColor="#F44336"
        callback={validateFailedToastCallback}
      ></Toast>
      <Toast
        show={showLoginFailedToast}
        message={t("__fbads_facebook_setting_error_occurred")}
        bgColor="#F44336"
        callback={loginFailedToastCallback}
      ></Toast>
      <LoadingContainer show={showLoadingContainer} borderRadius={10} />
      <LoginModal show={modalLoginFacebookDisplay} setShow={setModalLoginFacebookDisplay} reload={handleReload} />
    </StyledContainer>
  );
}

const SetupWrapperHeader = styled.div`
  display: flex;
  align-items: center;
`;

const SetupWrapperFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const SaveButton = styled(Button)`
  margin: 0px;
`;

const SetupTextHeader = styled(TextHeader)`
  font-size: 18px;
  margin-bottom: 10px;
`;

const StyledInput = styled(Input)`
  padding: 4px;
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
`;

const StyledContainer = styled.div`
  font-size: 14px;
  color: #555;
  position: relative;
`;

const SetupMainContainer = styled.div`
  background-color: #fbfeff;
  border-radius: 10px;
  border: 1px solid #f5f9fc;
  padding: 20px;
`;

const FlexGrowDiv = styled.div`
  flex-grow: 1;
`;

const StyledRow = styled(Row)`
  margin-top: 10px;
`;

const InputError = styled.div`
  display: none;
  color: red;
  font-size: 0.75em;

  &.input-error {
    display: flex;
    flex-wrap: wrap;
  }

  > a {
    color: red;
  }
`;

const ReLoginContainer = styled.div`
  cursor: pointer;
  color: #337ab7;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const LoginToRdynamicContainer = styled.div`
  background-color: #fffbe2;
  border: 1px solid #f7e7c5;
  width: 100%;
  text-align: center;
  padding: 10px;
`;

const LoginToRdynamicLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
  color: #337ab7;
`;

export default AdsSetup;
